import React from 'react'
import SimpleTable from 'components/Tables/SimpleTable'

export default ({ node }) => (
  <SimpleTable>
    <div>
      <div>Duration:</div>
      <div>{node.extras.length}s</div>
    </div>
  </SimpleTable>
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/Pause/PauseDisplay.jsx